import gifts from './../../../../image/gifts3.gif'
import stuyles from './Gifts.module.css'
import img from './../../../../image/185_SWIMMING.png'

export const Gifts = ()=>{
    return(
        <div className={stuyles.gifts_container}>
            <img src={img} style={{width:"100%", height:"auto"}}/>
        </div>
    )
}